import { ChevronDown } from "lucide-react";
import React, { useState } from "react";
import { NavLink } from "react-router-dom"; // Import NavLink for active link handling
import { useAppDispatch } from "../../redux/app/hooks";
import { closeSidebar } from "../../redux/features/modalSlice";

const SidebarLink = ({
  icon: Icon,
  label,
  to,
  children,
  onClick,
}: {
  icon: React.ElementType;
  label: string;
  to: string; // Added `to` for route path
  children?: React.ReactNode;
  onClick?: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useAppDispatch();

  return (
    <div>
      <NavLink
        to={to}
        className={({ isActive }) =>
          `flex items-center !no-underline justify-between w-full p-2 rounded hover:bg-bgHoverPrimary ${
            isActive && !children
              ? "bg-bgHoverPrimary border-l-4 border-white"
              : ""
          }`
        }
        onClick={() => {
          !children ? setIsOpen(false) : setIsOpen(!isOpen);
          !children && dispatch(closeSidebar());
          onClick && onClick();
        }}
      >
        <div className="flex items-center space-x-3 text-white">
          <Icon color="#fff" />
          <span>{label}</span>
        </div>
        {children && (
          <ChevronDown
            className={`transition-transform text-white ${
              isOpen ? "transform rotate-180" : ""
            }`}
          />
        )}
      </NavLink>
      {isOpen && children && (
        <div className="ml-8 mt-2 space-y-2">{children}</div>
      )}
    </div>
  );
};

export default SidebarLink;
